export const createAndParseHTMLString = (valueTitle: string) => {
  const h1 = document.createElement('h1');

  h1.style.fontFamily =
    'Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol';
  h1.style.fontSize = '32px';
  h1.style.lineHeight = '40px';
  h1.style.letterSpacing = '0px';

  // Set content
  h1.textContent = valueTitle;

  // Return the HTML string
  return h1.outerHTML;
};

enum IMAGE_TYPES {
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  PNG = 'image/png',
}

enum DOCUMENT_TYPES {
  PDF = 'application/pdf',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  PPT = 'application/vnd.ms-powerpoint',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ZIP = 'application/zip',
}

const IMAGES = {
  [IMAGE_TYPES.JPEG]: '.jpeg',
  [IMAGE_TYPES.JPG]: '.jpg',
  [IMAGE_TYPES.PNG]: '.png',
};
export const DOCUMENTS = {
  [DOCUMENT_TYPES.PDF]: '.pdf',
  [DOCUMENT_TYPES.DOC]: '.doc',
  [DOCUMENT_TYPES.DOCX]: '.docx',
  [DOCUMENT_TYPES.PPT]: '.ppt',
  [DOCUMENT_TYPES.PPTX]: '.pptx',
  [DOCUMENT_TYPES.XLS]: '.xls',
  [DOCUMENT_TYPES.XLSX]: '.xlsx',
  [DOCUMENT_TYPES.ZIP]: '.zip',
};

export const ACCEPTED_IMAGE_EXTENSIONS = Object.values({
  ...IMAGES,
}).join(',');

export const ACCEPTED_ALL_FILE_EXTENSIONS = Object.values({
  ...DOCUMENTS,
  ...IMAGES,
}).join(',');
